import JSZip from "jszip";

function fromBase64(base64) {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }
  return bytes;
}

function toBase64(bytes) {
  let binary = "";
  const chunkSize = 0x8000;
  for (let offset = 0; offset < bytes.length; offset += chunkSize) {
    const slice = bytes.subarray(offset, Math.min(offset + chunkSize, bytes.length));
    binary += String.fromCharCode(...slice);
  }
  return btoa(binary);
}

export async function extractZipEntriesJson(base64) {
  const archive = await JSZip.loadAsync(fromBase64(base64));
  const entries = [];
  for (const name of Object.keys(archive.files)) {
    const file = archive.files[name];
    if (file.dir) {
      continue;
    }
    const content = await file.async("uint8array");
    entries.push({
      path: file.name,
      base64: toBase64(content),
    });
  }
  return JSON.stringify(entries);
}

export async function sha256Hex(base64) {
  const digest = await crypto.subtle.digest("SHA-256", fromBase64(base64));
  return Array.from(new Uint8Array(digest), value => value.toString(16).padStart(2, "0")).join("");
}
